import React from 'react';
import { FDBox } from '@facet-wealth/design';
import MetaControlField from 'Components/UI/Meta/MetaForm/Components/MetaControlField';

const ScenarioSelectionAssumptionsLayout = () => {
  return (
    <FDBox>
      <FDBox paddingY={4}>
        <MetaControlField attr={'title'} />
      </FDBox>
      <MetaControlField attr={'sections'} />
    </FDBox>
  );
};

ScenarioSelectionAssumptionsLayout.defaultProps = {};

ScenarioSelectionAssumptionsLayout.propTypes = {};

export default ScenarioSelectionAssumptionsLayout;
